import { getCountry } from '@/utils/geographyUtils';

const getCountryOptions = () => {
  return getCountry().map(g => {
    return {
      label: g.name,
      value: g.name,
      code: g.code,
    };
  });
};

export { getCountryOptions };
